import cn from 'classnames';

interface IIconActionButtonProps {
  onClick: () => void;
  icon: string;
  title: string;
  outline?: 'default' | 'green';
  iconSize?: string;
  isActive?: boolean;
  className?: string;
}

const IconActionButton = ({
  onClick,
  icon,
  title,
  outline = 'default',
  iconSize = 'text-lg',
  isActive = false,
  className,
}: IIconActionButtonProps) => {
  let outlineColor = '';

  switch (outline) {
    case 'green':
      outlineColor = 'text-farm-shop-500 border-farm-shop-500';
      break;
    default:
      outlineColor = 'text-gray-500 border-gray-300';
      break;
  }

  return (
    <button
      className={cn(
        `flex  relative gap-2 px-2 py-1.5 justify-center items-center rounded-3xl text-sm border-[1px] ${outlineColor}`,
        className,
      )}
      onClick={onClick}
    >
      <i className={`${icon} ${iconSize}`} />
      {isActive && (
        <span className="absolute bg-red-600 rounded-full size-1.5 right-1.5 top-1"></span>
      )}
      <span>{title}</span>
    </button>
  );
};

export default IconActionButton;
